import incomeShareConstants from "../constants/incomeShareConstants";

const createIncomeShare = (payload: any) => ({
  type: incomeShareConstants.ADD_INCOME_SHARE_REQ,
  payload,
});

export const editIncomeShare = (payload: any) => ({
  type: incomeShareConstants.EDIT_INCOME_SHARE_REQUEST,
  payload,
});

export const retrieveIncomeShare = (payload: any) => ({
  type: incomeShareConstants.GET_INCOME_SHARE_REQUEST,
  payload,
});

export const addSpecificIncomeShare = (payload: any) => ({
  type: incomeShareConstants.SPECIFIC_INCOME_SHARE_REQUEST,
  payload,
});

export const getSpecificIncomeShare = (payload: any) => ({
  type: incomeShareConstants.GET_SPECIFIC_INCOME_REQUEST,
  payload,
});

export const resetIncomeShare = () => ({
  type: incomeShareConstants.RESET_INCOME_SHARE_REQUEST,
});

export default createIncomeShare;
